import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import { stringify } from 'qs';

var updatePageNumber = function updatePageNumber(query) {
  var addQuery = query ? "?".concat(stringify(query)) : '';

  if (window.history.pushState) {
    var path = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname).concat(addQuery);
    window.history.replaceState({
      path: path
    }, '', path);
  }
};

export default updatePageNumber;